import { create } from "zustand";
import _ from "lodash";
import { toast } from "react-toastify";
import {
  fetchAllProducts,
  fetchProductDetails,
  fetchSettingByKey,
} from "../api_layer/api";
import { SETTINGS_KEY, groupProducts, mapProductDetailsResponse } from "../helpers";

export const useRevampProductsStore = create((set, get) => ({
  products: [],
  productsLoading: false,
  mapping: {},
  mappingLoading: false,
  groupedProducts: {},
  productDetails: null,
  productDetailsLoading: false,
  error: null,

  fetchProductsAndMapping: async () => {
    const state = get();
    if (state.productsLoading) return;

    set({ productsLoading: true, mappingLoading: true, error: null });

    try {
      const [productsRes, settingsRes] = await Promise.all([
        fetchAllProducts(),
        fetchSettingByKey(SETTINGS_KEY),
      ]);

      const products = productsRes.data || [];

      let mapping = {};
      let settingValue = settingsRes?.data?.value ?? settingsRes?.data;
      if (settingValue) {
        try {
          if (typeof settingValue === "string") {
            settingValue = JSON.parse(settingValue);
          }
          mapping = Array.isArray(settingValue) ? settingValue[0] || {} : settingValue;
        } catch {
          mapping = {};
        }
      }

      const grouped = groupProducts(products, mapping);

      set({
        products,
        mapping,
        groupedProducts: grouped,
        productsLoading: false,
        mappingLoading: false,
      });
    } catch (error) {
      const fallbackError = _.get(error, ["message"], "Failed to fetch products");
      const errorMessage = _.get(
        error,
        ["response", "data", "message"],
        fallbackError
      );
      set({
        error: errorMessage,
        productsLoading: false,
        mappingLoading: false,
      });
      toast.error(errorMessage);
    }
  },

  fetchSingleProductDetails: async (variantId) => {
    set({ productDetailsLoading: true, productDetails: null });
    try {
      const response = await fetchProductDetails(variantId);
      const raw = (response.data || [])[0] || null;
      const details = mapProductDetailsResponse(raw);

      set({ productDetails: details, productDetailsLoading: false });
    } catch (error) {
      const fallbackError = _.get(error, ["message"], "Failed to fetch product details");
      const errorMessage = _.get(
        error,
        ["response", "data", "message"],
        fallbackError
      );
      set({ productDetailsLoading: false });
      toast.error(errorMessage);
    }
  },

  clearProductDetails: () => {
    set({ productDetails: null, productDetailsLoading: false });
  },
}));
